import { render, staticRenderFns } from "./GoodsFittingList.vue?vue&type=template&id=fec405e0&scoped=true"
import script from "./GoodsFittingList.vue?vue&type=script&lang=js"
export * from "./GoodsFittingList.vue?vue&type=script&lang=js"
import style0 from "./GoodsFittingList.vue?vue&type=style&index=0&id=fec405e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec405e0",
  null
  
)

export default component.exports